module.exports = __webpack_public_path__ + "fonts/NespressoLucas-MedItalic.eot?v=f0a075ef9d096cc19593fb0838ae83ca";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-MedItalic.eot?
// module id = 665
// module chunks = 0